import { useGlobalStore } from '../stores/global'

type Options = {
    url: string;
    id: number;
    cls: string;
    activeCls: string;
}

function doToggle(store: any, link: HTMLElement, options: Options) {
    const toggle = async () => {
        if (link.className === 'icon-spinner') {
            return;
        }
        link.className = 'icon-spinner';
        const res = await fetch(options.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: options.id,
                user_id: store.user.id,
            }),
        });

        if (!res.ok) {
            return false;
        }
        const data = await res.json();

        store.user.num_favorites = data.num_favorites;

        return data;
    }

    link.addEventListener('click', async (e) => {
        e.preventDefault();
        const res = await toggle();
        if (res.enabled) {
            link.className = options.activeCls;
        } else {
            link.className = options.cls;
        }
    });
}

export default function toggleFavorite(el: string, options: Options, callback: Function) {
    const link = document.querySelector(el) as HTMLElement;
    if (!link) {
        return;
    }

    const store = useGlobalStore();

    if (store.user.id) {
        doToggle(store, link, options);
    } else {
        callback();
    }
}